import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@betareader/design-system';
import { Trans } from 'react-i18next';

type Props = {
  toggleChapterUpload(): void;
};

const WelcomeMessage: React.FC<Props> = ({ toggleChapterUpload }) => (
  <Card style={{padding: '1.5rem', borderLeft: '4px solid var(--br-warning-border)'}}>
    <Trans i18nKey="DashboardWelcomeMessage">
      <h2 style={{ fontWeight: 'normal' }}>
        Welcome to BetaReader.io!
      </h2>
      <p style={{ fontWeight: 'lighter' }}>
        Start by&#39;{' '}
        <Link
          to="/mymanuscripts"
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            toggleChapterUpload();
          }}
        >
          uploading
        </Link>{' '}
        or{' '}
        <a href="/books/new" rel="noreferrer noopener">
          adding
        </a>{' '}
        your manuscript
      </p>
      <h3 style={{ fontWeight: 'normal' }}>
        Discovery
      </h3>
      <p style={{ fontWeight: 'lighter' }}>
        Don&#39;t forget to list your manuscript in our&nbsp;
        <a
          href="https://app.betareader.io/discover"
          target="_blank"
          rel="noreferrer noopener"
        >
          discovery
        </a>
        &nbsp; section, to access more beta readers.
      </p>
      <p style={{ fontWeight: 'lighter' }}>
        <a
          href="https://betareader.io/help/how-to-share-your-work"
          target="_blank"
          rel="noreferrer noopener"
        >
          Here
        </a>{' '}
        is a quick walkthrough of how to do that.
      </p>
      <h3 style={{ fontWeight: 'normal' }}>
        Support
      </h3>
      <p style={{ fontWeight: 'lighter' }}>
        Please check out our{' '}
        <a
          href="https://betareader.io/help"
          target="_blank"
          rel="noreferrer noopener"
        >
          help
        </a>{' '}
        portal or ping us directly by pressing the (?) at the top right of the
        page.
      </p>
      <p style={{ fontWeight: 'lighter' }}>
        You can always send us a friendly mail at{' '}
        <a href="mailto:hello@betareader.io" rel="noreferrer noopener">
          hello@betareader.io
        </a>
      </p>
    </Trans>
  </Card>
);

export default WelcomeMessage;
